import type { SVGProps } from 'react';

const SvgMexFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="15"
    fill="none"
    viewBox="0 0 22 15"
    {...props}
  >
    <g clipPath="url(#mex-flag_svg__a)">
      <path fill="#006847" d="M0 0h7.333v15H0z" />
      <path fill="#fff" d="M7.333 0h7.334v15H7.333z" />
      <path fill="#CE1126" d="M14.667 0H22v15h-7.333z" />
    </g>
    <defs>
      <clipPath id="mex-flag_svg__a">
        <rect width={22} height={15} fill="#fff" rx={1} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMexFlag;
